<template>
  <d-s-c-debug v-if="isDscDebug" :controller="controller" />

  <hikvision-debug v-else :controller="controller" />
</template>

<script>
import DSCDebug from './DSCDebug.vue';
import HikvisionDebug from './HikvisionDebug.vue';

export default {
  components: {
    HikvisionDebug,
    DSCDebug,
  },
  props: {
    controller: {
      type: Object,
      required: true,
    },
    isDscDebug: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
